import Screen from '../Screen';
import React, { FC, useState, useEffect } from 'react';
import styled from 'styled-components/native';
import Fonts from 'theme/fonts';
import Colors from 'theme/colors';
import { useHistory, useParams } from 'react-router-dom';
import SubtleAd from 'components/SubtleAd';
import HowToPractice from 'components/HowToPractice';
import SelectCard from 'components/SelectCard';
import manifestAPI from 'api/manifestAPI';
import { isLegacy } from 'config/sources';

const Hero = styled.View`
  background-color: ${Colors.WHITE};
  border-radius: 12px;
  border-width: 1px;
  border-color: ${Colors.CARD_BORDER};
  padding: 18px 16px;
  margin: 4px 8px 12px;
`;

const HeroTitle = styled(Fonts.Bold)`
  font-size: 22px;
  color: ${Colors.MAIN_COLOR};
  margin-bottom: 6px;
`;

const HeroText = styled(Fonts.Normal)`
  font-size: 15px;
  color: ${Colors.MUTED_TEXT};
  line-height: 22px;
`;

const SectionTitle = styled(Fonts.Bold)`
  font-size: 15px;
  color: ${Colors.TEXT};
  margin: 8px 12px 4px;
`;

const YearRow = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  margin: 8px 4px 4px;
`;

const YearChip = styled.TouchableOpacity`
  background-color: ${Colors.WHITE};
  border-width: 1px;
  border-color: ${Colors.CARD_BORDER};
  border-radius: 20px;
  padding: 8px 14px;
  margin: 4px;
`;

const YearChipText = styled(Fonts.Bold)`
  font-size: 14px;
  color: ${Colors.MAIN_COLOR};
`;

const EmptyText = styled(Fonts.Italic)`
  font-size: 15px;
  margin: 12px;
  color: ${Colors.MUTED_TEXT};
  text-align: center;
`;

const TestList: FC = () => {
  const history = useHistory();
  const { year } = useParams();

  const [testList] = useState<string[]>([
    'Test 1', 'Test 2', 'Test 3', 'Test 4', 'Test 5',
    'Test 6', 'Test 7', 'Test 8', 'Test 9', 'Test 10',
  ]);

  const [manifestTests, setManifestTests] = useState<any[]>([]);
  const [otherYears, setOtherYears] = useState<string[]>([]);

  useEffect(() => {
    const currentYear = year || '2020';
    manifestAPI.getRoot()
      .then((root: any) => {
        const extraYears = ((root && root.years) || []).map((y: any) => `${y}`);
        setOtherYears(['2020', '2021'].concat(extraYears).filter((y: string) => y !== currentYear));
      })
      .catch(() => {
        setOtherYears(['2020', '2021'].filter((y: string) => y !== currentYear));
      });
    if (!isLegacy(year)) {
      manifestAPI.getYear(year)
        .then((manifest: any) => setManifestTests((manifest && manifest.tests) || []))
        .catch(() => setManifestTests([]));
    }
  }, [year]);

  const currentYear = year || '2020';
  const currentTestList = isLegacy(year)
    ? testList
    : manifestTests.map((t: any) => `Test ${t.test}`);

  const openPartListScreen = (index: number) => {
    const testNumber = isLegacy(year) ? index + 1 : manifestTests[index].test;
    history.push(`/toeic${currentYear}/test${testNumber}`);
  };

  return (
    <Screen title={`TOEIC ${currentYear}`}>
      <Hero>
        <HeroTitle>Ôn luyện TOEIC Online</HeroTitle>
        <HeroText>
          Luyện Listening & Reading theo từng Part, chấm điểm ngay sau khi nộp bài.
          Phù hợp người mới bắt đầu và ôn trước kỳ thi.
        </HeroText>
      </Hero>

      <HowToPractice />

      <SectionTitle>{`Chọn bài Test · TOEIC ${currentYear}`}</SectionTitle>
      {!isLegacy(year) && currentTestList.length === 0 && (
        <EmptyText>{`Chưa có dữ liệu cho TOEIC ${currentYear}.`}</EmptyText>
      )}
      {currentTestList.map((label, index) => (
        <SelectCard
          key={`${label}_${index}`}
          title={label}
          subtitle="7 phần · Listening + Reading"
          meta="Bấm để chọn Part muốn ôn"
          onPress={() => openPartListScreen(index)}
        />
      ))}

      {otherYears.length > 0 && (
        <>
          <SectionTitle>Đề các năm khác</SectionTitle>
          <YearRow>
            {otherYears.map((otherYear: string) => (
              <YearChip
                key={otherYear}
                onPress={() => history.push(`/toeic${otherYear}`)}
              >
                <YearChipText>{`TOEIC ${otherYear}`}</YearChipText>
              </YearChip>
            ))}
          </YearRow>
        </>
      )}

      <SubtleAd />
    </Screen>
  );
};

export default TestList;
